import React from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import fighting from './assets/images/fighting.png';




const CSSLesson2 = () => {
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">
         
    <h3> <strong>Why is CSS Important</strong></h3>
    <p>It is possible for a website to run without CSS, but it certainly won't be pretty or attractive.</p>
    <p><b>CSS</b> makes the front-end of a website shine and it creates a memorable user experience.
    Without CSS, websites would be less pleasing to the eye and likely much harder to navigate.</p>
    <p>In addition to layout and format, CSS is responsible for font color and more.</p><br/>
    <div className="alert alert-secondary" role="alert">

    <h4><strong>Benefits of CSS</strong></h4>
    <ol class="list-group">
        <li class="list-group-item">Better user experience.</li>
        <li class="list-group-item">Faster development time.</li>
        <li class="list-group-item">Easy Formatting Changes.</li>
        <li class="list-group-item">Easy Maintenance.</li>
        <li class="list-group-item">Device Compatibility.</li>
    </ol>
    <br/>
    </div>

    <div className="alert alert-secondary" role="alert">

    <h4><strong>Difference between CSS and CSS3</strong></h4>

            <table className="table">
              <thead>
                <tr>
                  <th>CSS</th>
                  <th>CSS3</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>CSS was developed in 1996.</td>
                  <td>CSS3 was released in 2005 and is the latest version of CSS.</td>
                </tr>
                <tr>
                  <td>CSS is memory intensive.</td>
                  <td>CSS3 memory consumption is low as compared to CSS.</td>
                </tr>
                <tr>
                  <td>CSS does not support media queries.</td>
                  <td>CSS3 supports media queries.</td>
                </tr>
                <tr>
                  <td>Does not support any special effect like shadowing text, text animation, etc.</td>
                  <td>CSS3 has many advance features like text shadows, visual effects, and a wide range of font styles and colors.</td>
                </tr>
                <tr>
                  <td>CSS is slow compared to CSS3</td>
                  <td>CSS3 is faster</td>
                </tr>
              </tbody>
            </table>
            </div>

    
    
    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default CSSLesson2